export const ru = {
    collapse: 'Свернуть',
    expand: 'Развернуть'
};
